module.exports = __webpack_public_path__ + "static/media/paraflux-logo-circle.936d9e2b.png";